export const alertForDocumentToBeSignedNotAllowed = 'El documento debe ser de tipo pdf, doc o docx';
